import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
export type LeadKind = 'Consulta' | 'Solicitud de venta' | 'Financiación' | 'Permuta';
export interface LeadRecord {
  id: string;
  kind: LeadKind;
  estado: string;
  createdAt: string;
  data: Record<string, string>;
}
interface LeadsContextValue {
  consultas: LeadRecord[];
  solicitudesDeVenta: LeadRecord[];
  addLead: (kind: LeadKind, data: Record<string, string>, id?: string) => LeadRecord;
}
const LeadsContext = createContext<LeadsContextValue | null>(null);
export function LeadsProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [leads, setLeads] = useState<LeadRecord[]>([]);
  const addLead = useCallback((kind: LeadKind, data: Record<string, string>, id?: string) => {
    const record: LeadRecord = {
      id: id ?? `${kind === 'Solicitud de venta' ? 'VA' : 'CO'}-${Date.now().toString().slice(-6)}`,
      kind,
      estado: kind === 'Solicitud de venta' ? 'Pendiente de revisión' : 'Nueva consulta',
      createdAt: new Date().toISOString(),
      data
    };
    setLeads(prev => [record, ...prev]);
    return record;
  }, []);
  const value = useMemo<LeadsContextValue>(() => ({
    consultas: leads.filter(l => l.kind !== 'Solicitud de venta'),
    solicitudesDeVenta: leads.filter(l => l.kind === 'Solicitud de venta'),
    addLead
  }), [leads, addLead]);
  return <LeadsContext.Provider value={value} data-id="element-638" data-mp="2u5r718eqgo7y">{children}</LeadsContext.Provider>;
}
export function useLeads(): LeadsContextValue {
  const ctx = useContext(LeadsContext);
  if (!ctx) throw new Error('useLeads debe usarse dentro de LeadsProvider');
  return ctx;
}